<template>
  <div>
    <headerNav title="充值单据" />
    <div>
      <van-tabs v-model="tabCurrentIndex" @change="tabchange" sticky>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-tab :title="navitem.text" v-for="(navitem,navindex) in navList" :key="navindex">
            <van-list
              v-model="navitem.loaded"
              :finished="navitem.loadingType=='nomore'?true:false"
              :finished-text="navitem.loadingType=='nomore'?'没有更多了':'下拉加载更多'"
              @load="loadData"
            >
              <div v-for="(item,index) in navitem.List" class="mian-list" :key="index">
                
                <div class="mian-list-info">
                  <div class="mian-list-pic">
                      <img  v-lazy="$baseurl+item.proofPath">
                 </div>
                  <div class="main-list-info-main">
                       <div class="mian-list-info-data min-height">
                          <van-tag type="primary"  class="mian-list-info-left-tag" v-if="item.productType==1" size="medium">大货</van-tag>
                          <van-tag type="primary" class="mian-list-info-left-tag" v-if="item.productType==2" size="medium">物料</van-tag>
                        <van-tag
                            type="primary"
                            v-if="item.isAudit==0"
                            size="medium"
                          class="mian-list-info-right-tag" >{{item.isTransferOrder?'已转单':'待审核'}}</van-tag>

                          <van-tag type="success" class="mian-list-info-right-tag" v-if="item.isAudit==1" size="medium">已通过</van-tag>
                          <van-tag type="danger" class="mian-list-info-right-tag" v-if="item.isAudit==2" size="medium">已取消</van-tag>
                      </div>
                       <div class="mian-list-info-data">
                          <span>充值金额:</span>
                          <span>{{item.money}}</span>
                        </div>
                        <div class="mian-list-info-data">
                          <span>流水单号:</span>
                          <span>
                            {{item.tid}}
                            <br />
                            <span v-if="item.productType!=0">类型:{{item.productTypeName}}</span>
                            <div v-if="item.comment">备注:{{item.comment}}</div>
                          </span>
                        </div>
                         <div class="mian-list-info-data-last">
                            {{item.creationTime}}
                         </div>
                      </div>
                  </div>         
<!-- 
                <div class="mian-list-mark" v-if="item.comment">
                  <div>备注:{{item.comment}}</div>
                </div> -->
              </div>
            </van-list>
          </van-tab>
        </van-pull-refresh>
      </van-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      date: "",
      show: false,
      tabCurrentIndex: 0,
      navList: [
        {
          state: 0,
          text: "全部",
          loadingType: "more",
          loaded: false,
          getparams: {
            sorting: "",
            maxResultCount: 10,
            skipCount: 0,
          },
          List: [],
        },
        {
          state: 1,
          text: "待处理",
          loadingType: "more",
          loaded: false,
          getparams: {
            isAudit: 0,
            sorting: "",
            maxResultCount: 10,
            skipCount: 0,
          },
          List: [],
        },
        {
          state: 2,
          text: "取消",
          loadingType: "more",
          loaded: false,
          getparams: {
            isAudit: 2,
            sorting: "",
            maxResultCount: 10,
            skipCount: 0,
          },
          List: [],
        },
        {
          state: 1,
          text: "通过",
          loadingType: "more",
          loaded: false,
          getparams: {
            isAudit: 1,
            sorting: "",
            maxResultCount: 10,
            skipCount: 0,
          },
          List: [],
        },
      ],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageParams: {
        maxResultCount: 8,
        skipCount: 0,
      },
      totalCount: 0,
    };
  },
  methods: {
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.show = false;
      this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
    },
    tabchange() {
      this.loadData("tabChange");
    },
    onRefresh() {

      this.loadData("refresh");
    },
    loadData(source) {
      let index = this.tabCurrentIndex;
      let navItem = this.navList[index];
      // let state = navItem.state;

      if (source === "tabChange" && navItem.loaded === true) {
        //tab切换只有第一次需要加载数据
        return;
      }
      if (
        navItem.loadingType === "loading" ||
        navItem.loadingType === "nomore"
      ) {
        //防止重复加载
        if(source!="refresh")
        {
          return;
        }
      }
      if (source == "refresh"||navItem.loadingType=='refresh') {
        this.navList[index].List = [];
        this.navList[index].getparams.skipCount = 0;
      }
      navItem.loadingType = "loading";
      var params = navItem.getparams;
      //加载数据
      this.ajax
        .post("/api/services/app/PhoneWallet/QueryMyRechargeRecords", params)
        .then((x) => {
          this.navList[index].getparams.skipCount += this.navList[
            index
          ].getparams.maxResultCount;
          let totalcount = x.result.totalCount;
          this.navList[index].List = this.navList[index].List.concat(
            x.result.items
          );
          //console.log(this.navList);
          // item = Object.assign(item, this.orderStateExp(item.state));
          this.navList[index].loadingType =
            totalcount > this.navList[index].getparams.skipCount
              ? "more"
              : "nomore";
        })
        .finally(() => {
          this.$set(this.navList[index], "loaded", false);
          this.refreshing=false;
        });
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
        this.pageParams.skipCount = 0;
      }

      this.ajax
        .post(
          "/api/services/app/PhoneWallet/QueryMyRechargeRecords",
          this.pageParams
        )
        .then((x) => {
          const items = x.result.items;
          this.list.push(...x.result.items);
          this.pageParams.skipCount += this.pageParams.maxResultCount;
          this.totalCount = x.result.totalCount;
        })
        .finally(() => {
          this.loading = false;

          if (this.pageParams.skipCount >= this.totalCount) {
            this.finished = true;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.mian-list {
  background-color: #fff;
  font-size: 12px;
  border-radius: 8px;
  margin: 10px;
  padding: 10px;
  box-shadow: 1px 1px 4px #c3c3c3;
  line-height: 18px;
}

.mian-list-info {
  padding: 5px 0 5px 110px;
  font-size: 14px;
  position: relative;
  min-height: 100px;
  word-break: break-all;
}
.mian-list-pic{
  position: absolute;
  top: 50%;
  left:0;
  width: 100px;
  height: 100px;
  transform: translate(0,-50%);
}
.mian-list-pic img{
  width: 100%;
  height: 100%;
}
.mian-list-info-data:first {
  min-height: 30px;
  padding-right: 90px;
}
.mian-list-info-data-last{
  text-align: right;
}
.main-list-info-main{
  position:  relative;
}
.min-height
{
  min-height: 18px;
  margin-bottom: 5px;
}
.mian-list-info-left-tag
{
  position: absolute;
  left:0 ;
}
.mian-list-info-right {
  text-align: right;
}
.mian-list-info-right-tag {
  position: absolute;
  right: 0;
}
.mian-list-mark {
  border-top: 1px solid #e2e2e2;
  padding-top: 10px;
  font-size: 18px;
}
</style>
